import { rankWith, uiTypeIs, LayoutProps } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react'; 
import { getElements } from '../../../../../utils/DynamicForms';
import './style.scss';
type Props = LayoutProps; // use correct prop type

const ControlWithButtonWrapper = (props: Props) => {
  if (!props.visible) return null;
  const style = props.uischema.options?.style;
  return (
    <div className="wrapper">
      <div className="t-wrappe--content">
        {getElements(props.uischema).map((element, index) => {
          if (
            element.type === 'ButtonControl' ||
            element.type === 'ButtonWithAction'
          )
            return (
              <div className="control-wrapper">
                <div className="tru-form-item">
                  <label>""</label>
                  <div className="tru-column">
                    <div className={`btn-wrapper ${style}`}>
                      <ResolvedJsonFormsDispatch
                        {...props}
                        uischema={element}
                        key={index}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          return (
            <ResolvedJsonFormsDispatch
              {...props}
              uischema={element}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
};

export const ControlWithButtonWrapperEntry = {
  tester: rankWith(1, uiTypeIs('ControlWithButtonWrapper')),
  renderer: withJsonFormsLayoutProps(ControlWithButtonWrapper),
};
